import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";

import { IOrderTypeToDeliveryTypeMapping } from "@/store/types";

@Module({ name: "orderTypeToDeliveryTypeMapping", dynamic: true, store: Store, namespaced: true })
export default class OrderTypeToDeliveryTypeMappingModule extends VuexModule {

  @Action
  async getOrderTypeToDeliveryTypeMapping() {
    let url = "/orderTypeToDeliveryTypeMapping";
    const response = await api.getAsync(url)
    return response.data;
  }

  @Action
  async addOrderTypeToDeliveryTypeMapping(orderTypeToDeliveryTypeMapping: IOrderTypeToDeliveryTypeMapping) {
    return await api.postAsync("/orderTypeToDeliveryTypeMapping", orderTypeToDeliveryTypeMapping);
  }

  @Action
  async updateOrderTypeToDeliveryTypeMapping(orderTypeToDeliveryTypeMapping: IOrderTypeToDeliveryTypeMapping) {
    return await api.putAsync("/orderTypeToDeliveryTypeMapping", orderTypeToDeliveryTypeMapping);
  }
}
